import { Field } from "react-final-form";
import getConfig from "next/config";

import InputCheckbox from "@components/Form/Checkbox";
import { isRequired } from "@lib/validations";
const {
  publicRuntimeConfig: { settings },
} = getConfig();

const EditReviewModalTerms = () => {
  return (
    <>
      <Field
        name="termsAndContitions"
        component={InputCheckbox}
        type="checkbox"
        required
        label={
          <span className="inline-block mb-1 ml-1 font-normal text-sm">
            Prin adaugarea acestui review sunt de acord cu
            {` `}
            <a
              href={`${settings.baseUrl}/suport-clienti/informatii-generale-termeni-si-conditii/`}
              title="Termenii si Conditiile"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-sm text-red-lightdark"
            >
              Termenii si Conditiile*
            </a>
          </span>
        }
        validate={isRequired()}
      />

      <Field
        name="gdpr"
        component={InputCheckbox}
        type="checkbox"
        required
        label={
          <span className="inline-block mb-1 ml-1 font-normal text-sm">
            Sunt de acord cu
            {` `}
            <a
              href={`${settings.baseUrl}/nota-informare-date-caracter-personal/pag/`}
              title="Politica GDPR"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold text-sm text-red-lightdark"
            >
              politica GDPR*
            </a>
          </span>
        }
        validate={isRequired()}
      />
    </>
  );
};

export default EditReviewModalTerms;
